import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import TextField from './TextField';
import CountryDropdownField from './CountryDropdownField';
import { Validation } from '../../../services';

var ShareholderCompanyFieldGroup = function ShareholderCompanyFieldGroup(_ref) {
  var name = _ref.name,
      user = _ref.user;
  return React.createElement(Fragment, null, React.createElement(TextField, {
    label: 'Company Legal Name',
    name: "".concat(name, ".company_name"),
    placeholder: 'Enter Company Legal Name'
  }), React.createElement(TextField, {
    label: 'Address',
    name: "".concat(name, ".address"),
    placeholder: 'Enter Address'
  }), React.createElement(TextField, {
    label: 'City',
    name: "".concat(name, ".city"),
    placeholder: 'Enter City'
  }), React.createElement(TextField, {
    label: 'State',
    name: "".concat(name, ".state"),
    placeholder: 'Enter State'
  }), React.createElement(CountryDropdownField, {
    label: 'Country',
    name: "".concat(name, ".country"),
    placeholer: 'Select one of the following',
    user: user
  }), React.createElement(TextField, {
    label: '% of equity',
    type: 'number',
    name: "".concat(name, ".participation_percentage"),
    placeholder: 'Enter % of equity',
    validate: [Validation.percentageRange]
  }));
};

ShareholderCompanyFieldGroup.propTypes = {
  name: PropTypes.string.isRequired,
  user: PropTypes.object.isRequired
};
export default ShareholderCompanyFieldGroup;